(() => {
  if (window.__nsCartDock) return;
  const phone = /iPhone|iPod|Android.+Mobile/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 0 && innerWidth < 750);
  if (!phone) return;
  window.__nsCartDock = true;

  const state = { frame: 0, panel: null, source: null, slot: null, track: null, artwork: '' };
  const root = document.documentElement;

  const findArtwork = () => {
    if (state.artwork) return state.artwork;
    const footer = document.querySelector('footer.footer, .footer');
    if (!footer) return '';
    const elements = [footer, footer.parentElement, ...footer.querySelectorAll('*')].filter(Boolean);
    for (const element of elements) {
      const image = [null, '::before', '::after']
        .map((pseudo) => getComputedStyle(element, pseudo).backgroundImage)
        .find((value) => value?.includes('url('));
      if (image) return (state.artwork = image);
    }
    return '';
  };

  const restore = () => {
    if (state.panel && state.source?.isConnected) {
      const wallets = state.panel.querySelector('[data-ns-forced-vertical]');
      wallets?.classList.remove('additional-checkout-buttons--vertical');
      if (wallets) delete wallets.dataset.nsForcedVertical;
      state.panel.classList.remove('ns-cart-dock-panel');
      state.source.append(state.panel);
    }
    state.slot?.remove();
    state.track?.classList.remove('ns-cart-dock-track');
    state.slot = state.track = null;
  };

  const sync = () => {
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const nativePanel = footer?.querySelector('.cart__blocks');
    const panel = nativePanel || state.panel;
    const track = items?.closest('main') || items?.parentElement;
    const enabled = Boolean(
      items && track && panel?.querySelector('#checkout') &&
      panel.querySelector('.totals__total-value') &&
      !footer?.classList.contains('is-empty')
    );

    root.classList.toggle('ns-cart-dock-active', enabled);
    if (!enabled) return restore();

    if (nativePanel) {
      state.source = nativePanel.parentElement;
      if (state.panel && state.panel !== nativePanel) state.panel.remove();
      state.panel = nativePanel;
    }
    if (state.track !== track) {
      state.track?.classList.remove('ns-cart-dock-track');
      state.track = track;
      track.classList.add('ns-cart-dock-track');
    }
    if (!state.slot) {
      state.slot = document.createElement('div');
      state.slot.className = 'ns-cart-dock-slot';
    }
    if (state.slot.parentElement !== track || state.slot !== track.lastElementChild) {
      track.append(state.slot);
    }

    state.panel.classList.add('ns-cart-dock-panel');
    if (state.panel.parentElement !== state.slot) state.slot.append(state.panel);

    const wallets = state.panel.querySelector('.additional-checkout-buttons');
    if (wallets && !wallets.classList.contains('additional-checkout-buttons--vertical')) {
      wallets.classList.add('additional-checkout-buttons--vertical');
      wallets.dataset.nsForcedVertical = '';
    }
    const artwork = findArtwork();
    if (artwork) state.slot.style.setProperty('--ns-cart-footer-artwork', artwork);
  };

  const schedule = () => {
    cancelAnimationFrame(state.frame);
    state.frame = requestAnimationFrame(sync);
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
